import { baseApi } from 'app/baseApi';
import { baseQuery } from 'app/baseQuery';
import { apiTags } from 'app/store/apiTags';

const apiPrefix = 'issueTrackerRule';

export const issueTrackerRuleApi = baseApi.injectEndpoints({
    reducerPath: 'issueTrackerRuleApi',
    baseQuery: baseQuery,
    endpoints: (builder) => ({
        getIssueTrackerRules: builder.query({
            query: ({ clientAccountId }) => `${apiPrefix}?clientAccountId=${clientAccountId}`,
            providesTags: [apiTags.ISSUE_TRACKER_RULE],
        }),
        updateIssueTrackerRule: builder.mutation({
            query: body => ({
                url: `${apiPrefix}`,
                method: "PUT",
                body
            }),
            invalidatesTags: [apiTags.ISSUE_TRACKER_RULE],
        }),
        deleteIssueTrackerRule: builder.mutation({
            query: ({ id }) => ({
                url: `${apiPrefix}`,
                method: "DELETE",
                body: {
                    id
                }
            }),
            invalidatesTags: [apiTags.ISSUE_TRACKER_RULE]
        })
    }),
});


export const {
    useGetIssueTrackerRulesQuery,
    useUpdateIssueTrackerRuleMutation,
    useDeleteIssueTrackerRuleMutation,
} = issueTrackerRuleApi;
